import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const logo = "/assets/ABOUT US/Logo ACROE square.png";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#121212',
        color: '#FFD700',
        py: 6,
        borderTop: '1px solid rgba(255, 215, 0, 0.1)',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <img
              alt={"Logo"}
              src={logo}
              style={{
                width: "140px",
                margin: "-50px -10px -40px -10px",

              }} />
            {/*<Typography*/}
            {/*  variant="h6"*/}
            {/*  sx={{*/}
            {/*    mb: 2,*/}
            {/*  }}*/}
            {/*>*/}
            {/*  ACROE*/}
            {/*</Typography>*/}
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255, 215, 0, 0.7)',
                mb: 2,
                maxWidth: '300px',
              }}
            >
              <b>PT. ACROE INDONESIA</b><br/>
              Leading provider of Office and Workshop Equipment, One - Stop Solution for your needs.            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
              }}
            >
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <LocationOnIcon sx={{ mr: 1, color: 'rgba(255, 215, 0, 0.7)' }} />
              <Link
                href="https://maps.app.goo.gl/rYFLDLbW8zhKLVxo9"
                sx={{
                  color: 'rgba(255, 215, 0, 0.7)',
                  textDecoration: 'none',
                  '&:hover': { color: '#FFD700' },
                }}
              >
                Ruko Roxy Mas Blok C3 No. 5, Gambir, Cideng, Jakarta Pusat, DKI Jakarta, Indonesia
              </Link>
              {/*<Typography variant="body2" sx={{ color: 'rgba(255, 215, 0, 0.7)' }}>*/}
              {/*  Ruko Roxy Mas Blok C3 No. 5, Gambir, Cideng, Jakarta Pusat, DKI Jakarta, Indonesia*/}
              {/*</Typography>*/}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <WhatsAppIcon sx={{ mr: 1, color: 'rgba(255, 215, 0, 0.7)' }} />
              <Link
                href="https://wa.me/62816663699"
                sx={{
                  color: 'rgba(255, 215, 0, 0.7)',
                  textDecoration: 'none',
                  '&:hover': { color: '#FFD700' },
                }}
              >
                +62 816 663 699
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <PhoneIcon sx={{ mr: 1, color: 'rgba(255, 215, 0, 0.7)' }} />
              <Link
                href="tel:+62-21-6303-027"
                sx={{
                  color: 'rgba(255, 215, 0, 0.7)',
                  textDecoration: 'none',
                  '&:hover': { color: '#FFD700' },
                }}
              >
                +62 21 6303 027
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <EmailIcon sx={{ mr: 1, color: 'rgba(255, 215, 0, 0.7)' }} />
              <Link
                href="mailto:sales.jakarta@acroe.com"
                sx={{
                  color: 'rgba(255, 215, 0, 0.7)',
                  textDecoration: 'none',
                  '&:hover': { color: '#FFD700' },
                }}
              >
                sales.jakarta@acroe.com
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
              }}
            >
              Business Hours
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'rgba(255, 215, 0, 0.7)', mb: 1 }}
            >
              Monday - Friday: 9:00 AM - 5:00 PM WIB
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'rgba(255, 215, 0, 0.7)' }}
            >
              Saturday - Sunday: Closed
            </Typography>
          </Grid>
        </Grid>

        <Typography
          variant="body2"
          sx={{
            color: 'rgba(255, 215, 0, 0.5)',
            textAlign: 'center',
            mt: 4,
            pt: 2,
            borderTop: '1px solid rgba(255, 215, 0, 0.1)',
          }}
        >
          © {new Date().getFullYear()} ACROE. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
